import type { JSX } from "react";
import { qyTime } from "../../lib/qy-time";
export function CaliberBar(p: { asOf?: string | Date | null; computedAt?: string | Date | null; caliberVersion?: string | null; className?: string }): JSX.Element {
  return <div className={`qy-caliber-bar ${p.className ?? ""}`}>统计时点 {qyTime(p.asOf)} · 计算时间 {qyTime(p.computedAt)} · 口径版本 {p.caliberVersion?.trim() || "未记"}</div>;
}
